import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';

@customElement('visual-solar-luminar')
export class VisualSolarLuminar extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			width: 100%;
			height: 100%;
			overflow: hidden;
			padding-top: var(--header-height);
		}
		.container {
			display: flex;
			flex-direction: row;
			gap: 20px;
			width: 100%;
		}
		.left {
			padding: 5% 0 10% 0;
			flex-basis: 25%;
			width: 25%;
		}
		.middle {
			flex-basis: 25%;
			width: 25%;
		}
		.right {
			display: flex;
			flex-direction: column;
			justify-content: center;
			flex-basis: 50%;
			width: 50%;
			gap: 50px;
		}
		.img {
			width: 100%;
		}

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
	}
	render() {
		const s = this.state;
		return html`
			<div class="container">
				<div class="left">
					<svg-aeto-drawing></svg-aeto-drawing>
				</div>
				<div class="middle">
					<svg-aeto></svg-aeto>
				</div>
				<div class="right">
					<svg-aeto-lightdistribution></svg-aeto-lightdistribution>
					<svg-housingcolour></svg-housingcolour>
				</div>
			</div>
		`;
	}
}
